import React from 'react';
import { cn } from '../../lib/utils';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "block w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400",
          // Enhanced styling for better text visibility
          "font-mono leading-relaxed tracking-wide",
          // Better contrast and readability
          "text-gray-900 dark:text-gray-100",
          // Improved line height for better readability
          "leading-7",
          className
        )}
        style={{
          fontFamily: 'Monaco, Consolas, "Lucida Console", "Courier New", monospace',
          fontSize: '14px',
          lineHeight: '1.6',
          letterSpacing: '0.5px'
        }}
        ref={ref}
        {...props}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export { Textarea };